import { render, staticRenderFns } from "./scrapForm.vue?vue&type=template&id=5b6a7d40&scoped=true&"
import script from "./scrapForm.vue?vue&type=script&lang=js&"
export * from "./scrapForm.vue?vue&type=script&lang=js&"
import style0 from "./scrapForm.vue?vue&type=style&index=0&id=5b6a7d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a7d40",
  null
  
)

export default component.exports